import { FormCustomCheckbox } from "../yoello-lib/modules/dynamicForms/CustomFormComponents/FormCustomCheckbox";
import FormSwitchWithText from "../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";


const generateDays = () => {
  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  return days.map((day) => {
    return {
      label: `forms.tradingTimes.${day}`,
      keyName: day,
      Component: FormCustomCheckbox,
      gridColumnOptions: {
        formCol: 1
      }
    } as IDynamicFormRow;
  });
};

export const createTradingTimesFormRows = (
  t: (key: string) => string,
  enabledClassName: string
): IDynamicFormRow[] => {
  return [
    ...generateDays(),
    {
      label: "",
      keyName: "enabled",
      Component: FormSwitchWithText,
      formProps: {
        label: t("forms.tradingTimes.active"),
        labelPosition: "start",
      },
      gridColumnOptions: {
        formCol: 5,
      },
      className: enabledClassName,
    },
    {
      label: "forms.tradingTimes.from",
      keyName: "open_from",
      Component: FormTextBox,
      gridColumnOptions: {
        formCol: 2,
      },
      registerOptions: {
        required: true,
      },
      inputProperties: {
        type: "time",
        placeholder: t("forms.tradingTimes.placeholderStart"),
      },
    },
    {
      label: "forms.tradingTimes.to",
      keyName: "open_to",
      Component: FormTextBox,
      gridColumnOptions: {
        formCol: 2,
      },
      inputProperties: {
        type: "time",
        placeholder: t("forms.tradingTimes.placeholderEnd"),
      },
    },
    {
      label: "forms.tradingTimes.public_name",
      keyName: "name_public",
      Component: FormTextBox,
      gridColumnOptions: {
        formCol: 4,
      },
      registerOptions: {
        required: true,
      },
    },
  ];
};
